export function toDollars(cents: number): number {
  return Math.floor(cents / 100)
}
